const POVTypes = {
  GET_VENDOR_PURCHASE_ORDER_LIST_PROGRESS: 'POV_TYPE.GET_VENDOR_PURCHASE_ORDER_LIST_PROGRESS',
  GET_VENDOR_PURCHASE_ORDER_LIST_SUCCESS: 'POV_TYPE.GET_VENDOR_PURCHASE_ORDER_LIST_SUCCESS',
  GET_VENDOR_PURCHASE_ORDER_LIST_ERROR: 'POV_TYPE.GET_VENDOR_PURCHASE_ORDER_LIST_ERROR',
  GET_PO_INFO_PROGRESS: 'POV_TYPE.GET_PO_INFO_PROGRESS',
  GET_PO_INFO_SUCCESS: 'POV_TYPE.GET_PO_INFO_SUCCESS',
  GET_PO_INFO_ERROR: 'POV_TYPE.GET_PO_INFO_ERROR',
  SET_PO_INFO_DEFAULT: 'POV_TYPE.SET_PO_INFO_DEFAULT',
  SAVE_REGULAR_ORDER_DATA_SUCCESS: 'POV_TYPE.SAVE_REGULAR_ORDER_DATA_SUCCESS',
  SAVE_REGULAR_ORDER_DATA_PROGRESS: 'POV_TYPE.SAVE_REGULAR_ORDER_DATA_PROGRESS',
  REGULAR_ORDER_DATA_RESET: 'POV_TYPE.REGULAR_ORDER_DATA_RESET',
  SAVE_REGULAR_ORDER_DATA_ERROR: 'POV_TYPE.SAVE_REGULAR_ORDER_DATA_ERROR',
  GET_PACKAGE_INFO_PROGRESS: 'POV_TYPE.GET_PACKAGE_INFO_PROGRESS',
  GET_PACKAGE_INFO_SUCCESS: 'POV_TYPE.GET_PACKAGE_INFO_SUCCESS',
  GET_PACKAGE_INFO_ERROR: 'POV_TYPE.GET_PACKAGE_INFO_ERROR',
  SET_PACKAGE_MODAL_TOGGLE: 'PO_TYPE.SET_PACKAGE_MODAL_TOGGLE',
  SAVE_PACKAGE_DETAILS_SUCCESS: 'POV_TYPE.SAVE_PACKAGE_DETAILS_SUCCESS',
  SAVE_PACKAGE_DETAILS_PROGRESS: 'POV_TYPE.SAVE_PACKAGE_DETAILS_PROGRESS',
  SAVE_PACKAGE_DETAILS_ERROR: 'POV_TYPE.SAVE_PACKAGE_DETAILS_ERROR',
  SAVE_SHIPMENT_DETAILS_SUCCESS: 'POV_TYPE.SAVE_SHIPMENT_DETAILS_SUCCESS',
  SAVE_SHIPMENT_DETAILS_PROGRESS: 'POV_TYPE.SAVE_SHIPMENT_DETAILS_PROGRESS',
  SAVE_SHIPMENT_DETAILS_ERROR: 'POV_TYPE.SAVE_SHIPMENT_DETAILS_ERROR',
  SET_PURCHASE_ORDER_TOTAL_COUNT: 'POV_TYPE.SET_PURCHASE_ORDER_TOTAL_COUNT',
  SET_VENDOR_PURCHASE_ORDER_LIST: 'POV_TYPE.SET_VENDOR_PURCHASE_ORDER_LIST',
  GET_VENDOR_SHIPPER_LIST_PROGRESS: 'POV_TYPE.GET_VENDOR_SHIPPER_LIST_PROGRESS',
  GET_VENDOR_SHIPPER_LIST_SUCCESS: 'POV_TYPE.GET_VENDOR_SHIPPER_LIST_SUCCESS',
  GET_VENDOR_SHIPPER_LIST_ERROR: 'POV_TYPE.GET_VENDOR_SHIPPER_LIST_ERROR',
  GET_VENDOR_CONSIGNEE_LIST_PROGRESS: 'POV_TYPE.GET_VENDOR_CONSIGNEE_LIST_PROGRESS',
  GET_VENDOR_CONSIGNEE_LIST_SUCCESS: 'POV_TYPE.GET_VENDOR_CONSIGNEE_LIST_SUCCESS',
  GET_VENDOR_CONSIGNEE_LIST_ERROR: 'POV_TYPE.GET_VENDOR_CONSIGNEE_LIST_ERROR',
  GET_VENDOR_SHIPMENT_DETAIL_LIST_PROGRESS: 'POV_TYPE.GET_VENDOR_SHIPMENT_DETAIL_LIST_PROGRESS',
  GET_VENDOR_SHIPMENT_DETAIL_LIST_SUCCESS: 'POV_TYPE.GET_VENDOR_SHIPMENT_DETAIL_LIST_SUCCESS',
  GET_VENDOR_SHIPMENT_DETAIL_LIST_ERROR: 'POV_TYPE.GET_VENDOR_SHIPMENT_DETAIL_LIST_ERROR',
  GET_VENDOR_SHIPMENT_ITEM_DETAIL_LIST_PROGRESS: 'POV_TYPE.GET_VENDOR_SHIPMENT_ITEM_DETAIL_LIST_PROGRESS',
  GET_VENDOR_SHIPMENT_ITEM_DETAIL_LIST_SUCCESS: 'POV_TYPE.GET_VENDOR_SHIPMENT_ITEM_DETAIL_LIST_SUCCESS',
  GET_VENDOR_SHIPMENT_ITEM_DETAIL_LIST_ERROR: 'POV_TYPE.GET_VENDOR_SHIPMENT_ITEM_DETAIL_LIST_ERROR',
  GET_BAR_CODE: 'POV_TYPE.GET_BAR_CODE',
  GET_BAR_CODE_SUCCESS: 'POV_TYPE.GET_BAR_CODE_SUCCESS',
  GET_BAR_CODE_FAIL: 'POV_TYPE.GET_BAR_CODE_FAIL',
  GET_VENDOR_SHIPMENT_SUMMARY_LIST_PROGRESS: 'POV_TYPE.GET_VENDOR_SHIPMENT_SUMMARY_LIST_PROGRESS',
  GET_VENDOR_SHIPMENT_SUMMARY_LIST_SUCCESS: 'POV_TYPE.GET_VENDOR_SHIPMENT_SUMMARY_LIST_SUCCESS',
  GET_VENDOR_SHIPMENT_SUMMARY_LIST_ERROR: 'POV_TYPE.GET_VENDOR_SHIPMENT_SUMMARY_LIST_ERROR',
  GET_VENDOR_SHIPMENT_LADING_LIST_PROGRESS: 'POV_TYPE.GET_VENDOR_SHIPMENT_LADING_LIST_PROGRESS',
  GET_VENDOR_SHIPMENT_LADING_LIST_SUCCESS: 'POV_TYPE.GET_VENDOR_SHIPMENT_LADING_LIST_SUCCESS',
  GET_VENDOR_SHIPMENT_LADING_LIST_ERROR: 'POV_TYPE.GET_VENDOR_SHIPMENT_LADING_LIST_ERROR',
  SET_SELECTED_CONSIGNEE: 'PO_TYPE.SET_SELECTED_CONSIGNEE',
  SET_SELECTED_SHIPPER: 'PO_TYPE.SET_SELECTED_SHIPPER',
  CREATE_SHIPMENT_SUCCESS: 'POV_TYPE.CREATE_SHIPMENT_SUCCESS',
  CREATE_SHIPMENT_PROGRESS: 'POV_TYPE.CREATE_SHIPMENT_PROGRESS',
  CREATE_SHIPMENT_ERROR: 'POV_TYPE.CREATE_SHIPMENT_ERROR',
  CREATE_SHIPMENT_RESET: 'POV_TYPE.CREATE_SHIPMENT_RESET',
  SET_SELECTED_SHIPMENT_ITEM_DETAIL: 'PO_TYPE.SET_SELECTED_SHIPMENT_ITEM_DETAIL',
  SET_REMOVED_SHIPMENT_ITEM_DETAIL: 'PO_TYPE.SET_REMOVED_SHIPMENT_ITEM_DETAIL',
  SET_SELECTED_SHIPMENT_SUMMARY: 'PO_TYPE.SET_SELECTED_SHIPMENT_SUMMARY',
  SET_SAVE_SHIPMENT_DATA: 'POV_TYPE.SET_SAVE_SHIPMENT_DATA',
  CANCEL_SHIPMENT_SUCCESS: 'POV_TYPE.CANCEL_SHIPMENT_SUCCESS',
  CANCEL_SHIPMENT_RESET: 'POV_TYPE.CANCEL_SHIPMENT_RESET',
  CANCEL_SHIPMENT_PROGRESS: 'POV_TYPE.CANCEL_SHIPMENT_PROGRESS',
  CANCEL_SHIPMENT_ERROR: 'POV_TYPE.CANCEL_SHIPMENT_ERROR',

  // Vendor address
  GET_VENDOR_SEARCH: 'PO_TYPE.GET_VENDOR_SEARCH',
  GET_VENDOR_SEARCH_SUCCESS: 'PO_TYPE.GET_VENDOR_SEARCH_SUCCESS',
  GET_VENDOR_SEARCH_FAIL: 'PO_TYPE.GET_VENDOR_SEARCH_FAIL',
  GET_VENDOR_SEARCH_CLEAR: 'PO_TYPE.GET_VENDOR_SEARCH_CLEAR',
  GET_VENDOR_SEARCH_UPDATE: 'PO_TYPE.GET_VENDOR_SEARCH_UPDATE',
  GET_VENDOR_SEARCH_FILTER: 'PO_TYPE.GET_VENDOR_SEARCH_FILTER',

  ADD_VENDOR_ADDRESS_RECORD: 'PO_TYPE.ADD_VENDOR_ADDRESS_RECORD',

  SAVE_VENDOR_ADDRESS_SUCCESS: 'POV_TYPE.SAVE_VENDOR_ADDRESS_SUCCESS',
  SAVE_VENDOR_ADDRESS_PROGRESS: 'POV_TYPE.SAVE_VENDOR_ADDRESS_PROGRESS',
  SAVE_VENDOR_ADDRESS_ERROR: 'POV_TYPE.SAVE_VENDOR_ADDRESS_ERROR',
  SAVE_VENDOR_ADDRESS_RESET: 'PO_TYPE.SAVE_VENDOR_ADDRESS_RESET',

  DELETE_VENDOR_ADDRESS: 'PO_TYPE.DELETE_VENDOR_ADDRESS',
  DELETE_VENDOR_ADDRESS_SUCCESS: 'PO_TYPE.DELETE_VENDOR_ADDRESS_SUCCESS',
  DELETE_VENDOR_ADDRESS_FAIL: 'PO_TYPE.DELETE_VENDOR_ADDRESS_FAIL',
  DELETE_VENDOR_ADDRESS_RESET: 'PO_TYPE.DELETE_VENDOR_ADDRESS_RESET',

  SET_SELECT_ALL_CHECK_POV: 'PO_TYPE.SET_SELECT_ALL_CHECK_POV',

  REMOVE_VENDOR_SUMMARY_LIST: 'PO_TYPE.REMOVE_VENDOR_SUMMARY_LIST',

  GET_CUSTOMER_ROUTING_SETTING: 'PO_TYPE.GET_CUSTOMER_ROUTING_SETTING',
  GET_CUSTOMER_ROUTING_SETTING_SUCCESS: 'PO_TYPE.GET_CUSTOMER_ROUTING_SETTING_SUCCESS',
  GET_CUSTOMER_ROUTING_SETTING_FAIL: 'PO_TYPE.GET_CUSTOMER_ROUTING_SETTING_FAIL',
  RESET_ORDER_LIST: 'RESET_ORDER_LIST',
  RESET_ORDER_LIST_SUCCESS: 'RESET_ORDER_LIST_SUCCESS',
  RESET_ORDER_LIST_FAIL: 'RESET_ORDER_LIST_FAIL',
  GET_ROUTING_GUIDE: 'GET_ROUTING_GUIDE',
  GET_ROUTING_GUIDE_SUCCESS: 'GET_ROUTING_GUIDE_SUCCESS',
  GET_ROUTING_GUIDE_ERROR: 'GET_ROUTING_GUIDE_ERROR',
  SET_PAYLOAD_SHIP_DATA: 'SET_PAYLOAD_SHIP_DATA',

  PACKAGE_LOAD_TYPE_DATA: 'PACKAGE_LOAD_TYPE_DATA',
};

export default POVTypes;
